module.exports = __webpack_public_path__ + "static/media/huanjing6.0f8f46e9.png";